import { useDispatch } from "react-redux";
import withUpdatePromise from "./withUpdatePromise";
import {
  itemToBag,
  itemToBagFailure,
  itemToBagIntent,
  updateSavedItem
} from "../../../../state/actions";
import CustomerItemsProductTileControls from "../../../presentational/customerItems/ProductTileControls";
import isBackInStockNotificationEnabled from "../../../../state/modules/backInStock/isBackInStockEnabled";

const ProductTileControlsContainer = props => {
  const dispatch = useDispatch();
  const CustomerItemsProductTileControlsWithUpdatePromise = withUpdatePromise(
    CustomerItemsProductTileControls
  );

  return (
    <CustomerItemsProductTileControlsWithUpdatePromise
      itemToBag={(...args) => dispatch(itemToBag(...args))}
      itemToBagFailure={(...args) => dispatch(itemToBagFailure(...args))}
      itemToBagIntent={(...args) => dispatch(itemToBagIntent(...args))}
      updateSavedItem={(...args) => dispatch(updateSavedItem(...args))}
      isBackInStockNotificationEnabled={isBackInStockNotificationEnabled()}
      {...props}
    />
  );
};

export default ProductTileControlsContainer;
